
import {defineComponent} from "vue";
import CbFormTextWithImage from "@/components/layouts/content-blocks/forms/CbFormTextWithImage.vue";
import {PageDetailModeEnum} from "@/models/enum/PageDetailModeEnum";

export default defineComponent({
  name: "StandardHomepageContentBlocksDetail",
  computed: {
    PageDetailModeEnum() {
      return PageDetailModeEnum
    }
  },
  components: {CbFormTextWithImage},
  props: ['mode'],
  data() {
    return {
      cbId: this.$route.params.id as String,
    };
  },
  mounted() {
    const menuItem = document.getElementById('content-detail');
    if (menuItem != null) {
      menuItem.classList.add('active', 'router-link-exact-active');
    }
  }
});
